import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import './index.css';
import { initTheme } from './lib/theme';

// Before first paint, so a dark-mode user never sees a white flash.
initTheme();

/**
 * The composition root. Provider order matters and reads outside-in:
 *
 *   StrictMode    - dev-only double-render to surface impure effects
 *     BrowserRouter - must wrap anything using useLocation/useNavigate,
 *                     including ProtectedRoute
 *       AuthProvider  - needs the router, because a session expiry redirects
 *         App
 */
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
